import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Button,
  Input,
  Label,
  Spinner,
  Row,
  Col
} from "reactstrap";
import axios from "axios";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const UploadDescriptionModal = ({
  isOpen,
  onClose,
  onSave,
  dish
}) => {
  const [recipeTab, setRecipeTab] = useState("text");
  const [textInput, setTextInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);


  /* Reset on open */
  useEffect(() => {
    if (isOpen) {
      setRecipeTab("text");
      setTextInput("");
      setLoading(false);
      setSelectedImage(null);
      setPreviewUrl(null);
    }
  }, [isOpen]);


  /* Image → API → Text */
  const analyzeImage = async (file) => {
    try {
      setLoading(true);

      const res = await postDataAPI({
        serviceName: "server_data",
        op: "analyze-image",
        image: file,
        dishName: dish?.item_name,
        category: dish?.course_name
      });

      if (res.status === "ok") {
        setTextInput(res.data.description || "");
        setRecipeTab("text");
      }
    } catch (err) {
      alert("Image analysis failed");
    } finally {
      setLoading(false);
    }
  };

  const handleImageSelect = (file) => {
    if (!file) return;

    setSelectedImage(file);
    setPreviewUrl(URL.createObjectURL(file));
  };


  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose}>
        <i className="ri-upload-cloud-line me-2" />
        Upload Description for {dish?.item_name}
      </ModalHeader>

      <ModalBody>
        {/* TABS */}
        <Nav pills className="bg-light rounded p-1 mb-3">
          <NavItem className="flex-fill text-center">
            <NavLink
              className={recipeTab === "text" ? "active" : ""}
              onClick={() => setRecipeTab("text")}
              style={{ cursor: "pointer" }}
            >
              <i className="ri-file-text-line me-1" /> Text Description
            </NavLink>
          </NavItem>

          <NavItem className="flex-fill text-center">
            <NavLink
              className={recipeTab === "picture" ? "active" : ""}
              onClick={() => setRecipeTab("picture")}
              style={{ cursor: "pointer" }}
            >
              <i className="ri-image-line me-1" /> Upload Picture
            </NavLink>
          </NavItem>
        </Nav>

        {/* TAB CONTENT */}
        {recipeTab === "text" && (
          <>
            <Label className="text-muted small mb-2">
              Dish Description
            </Label>

            <Input
              type="textarea"
              rows="5"
              placeholder="Paste or type your dish description here..."
              value={textInput}
              onChange={(e) => setTextInput(e.target.value)}
            />
          </>
        )}

        {recipeTab === "picture" && (
          <>
            <Label className="text-muted small mb-2">
              Upload Dish Image
            </Label>

            {/* <Input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) analyzeImage(file);
              }}
            /> */}
            <Input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) handleImageSelect(file);
              }}
            />

            {previewUrl && (
              <div className="mt-3 text-center">
                <img
                  src={previewUrl}
                  alt="Preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: 250,
                    borderRadius: 8,
                    objectFit: "cover"
                  }}
                />

                <div className="mt-3">
                  <Button
                    color="primary"
                    size="sm"
                    disabled={loading}
                    onClick={() => analyzeImage(selectedImage)}
                  >
                    {loading ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Analyzing image...
                      </>
                    ) : (
                      <>Analyze Image</>
                    )}
                  </Button>
                </div>
              </div>
            )}



            {/* {loading && (
              <div className="text-center mt-3">
                <Spinner size="sm" /> Analyzing image...
              </div>
            )} */}
          </>
        )}

        {/* FOOTER */}
        <div className="d-flex justify-content-end gap-2 mt-4">
          <Button outline onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            disabled={!textInput || loading}
            onClick={() => onSave(textInput)}
          >
            <i className="ri-save-line me-1" /> Save
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UploadDescriptionModal;
